import type { LayoutIssue, LibraryBlock, SectionsFile } from '~/lib/plugin-sdk-layout';
import httpClient from '~/lib/http-client';

// Owner-facing Blocks plugin API (studio `BlocksOwnerController`): the
// Sections panel. `appId` is the CHAT id. Every call needs the app's sandbox
// running (503 `sandbox_not_running` otherwise: open the preview first).

export interface BlockLibraryView {
  blocks: LibraryBlock[];
  problems: LayoutIssue[];
  /** frontend/src/dunea/blocks.tsx exists in the app. */
  runtime: boolean;
  sync: { written: string[]; removed: string[]; pruned: number; pending: boolean } | { error: string };
}

export interface LayoutView {
  document: SectionsFile;
  /** Send back on save; a stale one gets 409. */
  version: string;
  exists: boolean;
  valid: boolean;
  errors: LayoutIssue[];
  warnings: LayoutIssue[];
}

const base = (appId: string) => `/api/plugins/blocks/apps/${encodeURIComponent(appId)}`;

export async function apiBlockLibrary(appId: string): Promise<BlockLibraryView> {
  const { data } = await httpClient.get<BlockLibraryView>(`${base(appId)}/library`);
  return data;
}

export async function apiGetLayout(appId: string): Promise<LayoutView> {
  const { data } = await httpClient.get<LayoutView>(`${base(appId)}/layout`);
  return data;
}

export async function apiSaveLayout(appId: string, document: SectionsFile, version: string): Promise<LayoutView> {
  const { data } = await httpClient.put<LayoutView>(`${base(appId)}/layout`, { document, version });
  return data;
}
